var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2519_43494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 7.5013L9.99935 4.16797L1.66602 7.5013L9.99935 10.8346L18.3327 7.5013ZM18.3327 7.5013V12.5013",
    stroke: "#F0A818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8.83203V13.332C5 13.9951 5.52678 14.631 6.46447 15.0998C7.40215 15.5686 8.67392 15.832 10 15.832C11.3261 15.832 12.5979 15.5686 13.5355 15.0998C14.4732 14.631 15 13.9951 15 13.332V8.83203",
    stroke: "#F0A818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2519_43494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore);
export default __webpack_public_path__ + "static/media/score.afa3853247c6e194d17b33e24c71fa14.svg";
export { ForwardRef as ReactComponent };